import { useState } from "react";
import moment from "moment";
import { Button, Grid } from "@material-ui/core";
import { IsMobile } from "utils/is-mobile";
import FromToDateField from "components/_refactor/fields/from-to-date";

export const DateField = ({ label, isLoading, onSubmit }) => {
  const [initialDate, setInitialDate] = useState("");
  const [finalDate, setFinalDate] = useState("");

  const isMobile = IsMobile();

  const handleSubmit = () => {
    onSubmit(initialDate, finalDate);
  };

  return (
    <Grid container spacing={2} justify="center">
      <Grid item xs={isMobile ? "12" : "10"}>
        <FromToDateField
          label={label}
          disabled={isLoading}
          isMobile={isMobile}
          searching={isLoading}
          initialDate={typeof initialDate === "string" ? initialDate : ""}
          finalDate={typeof finalDate === "string" ? finalDate : ""}
          setInitialDate={(value) => {
            setInitialDate(moment(value).format("YYYY-MM-DD"));
          }}
          setFinalDate={(value) => {
            setFinalDate(moment(value).format("YYYY-MM-DD"));
          }}
        />
      </Grid>
      <Grid item xs={isMobile ? "12" : "2"} justify="center">
        <Button
          style={
            isMobile
              ? { width: "100%", margin: "0.75rem 0" }
              : { marginBottom: "0rem", marginLeft: "0.5rem" }
          }
          color="default"
          variant="contained"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Pesquisando..." : "Pesquisar"}
        </Button>
      </Grid>
    </Grid>
  );
};
